class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.currentIndex = 0;
    this.announcementInterval = null;
    this.track = this.querySelector(".wt-announcement__slider-track");

    this.changeAnnouncement = this.changeAnnouncement.bind(this);
    this.previousAnnouncement = this.previousAnnouncement.bind(this);
    this.restartInterval = this.restartInterval.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchMove = this.handleTouchMove.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);

    this.touchStartX = 0;
    this.touchEndX = 0;
  }

  connectedCallback() {
    const slides = this.querySelectorAll('.wt-announcement__slide');

    if (slides.length > 1) {
      this.announcementInterval = setInterval(this.changeAnnouncement, 5000);

      // Swipe support
      this.addEventListener("touchstart", this.handleTouchStart, { passive: true });
      this.addEventListener("touchmove", this.handleTouchMove, { passive: true });
      this.addEventListener("touchend", this.handleTouchEnd, { passive: true });
    }

    const closeBtn = this.querySelector(".wt-announcement__close");
    if (closeBtn) {
      closeBtn.addEventListener("click", this.hideForOneDay);
    }
  }

  changeAnnouncement() {
    const slides = this.querySelectorAll('.wt-announcement__slide');
    if (!slides.length) return;

    this.currentIndex = (this.currentIndex + 1) % slides.length;
    this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
  }

  previousAnnouncement() {
    const slides = this.querySelectorAll('.wt-announcement__slide');
    if (!slides.length) return;

    this.currentIndex = (this.currentIndex - 1 + slides.length) % slides.length;
    this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
  }

  handleTouchStart(e) {
    this.touchStartX = e.touches[0].clientX;
  }

  handleTouchMove(e) {
    this.touchEndX = e.touches[0].clientX;
  }

  handleTouchEnd() {
    const swipeThreshold = 30;
    if (Math.abs(this.touchEndX - this.touchStartX) > swipeThreshold) {
      if (this.touchEndX < this.touchStartX) {
        this.changeAnnouncement(); // Swipe left
      } else {
        this.previousAnnouncement(); // Swipe right
      }
    }
    this.restartInterval();
  }

  restartInterval() {
    clearInterval(this.announcementInterval);
    this.announcementInterval = setInterval(this.changeAnnouncement, 5000);
  }

  hideForOneDay() {
    const oneDayLater = new Date().getTime() + 24 * 60 * 60 * 1000;
    localStorage.setItem("wt-announcement-hidden", oneDayLater);
    this.style.display = "none";
  }

  disconnectedCallback() {
    clearInterval(this.announcementInterval);
    this.removeEventListener("touchstart", this.handleTouchStart);
    this.removeEventListener("touchmove", this.handleTouchMove);
    this.removeEventListener("touchend", this.handleTouchEnd);
  }
}

customElements.define("announcement-bar", AnnouncementBar);
